import { store } from 'app_storage/redux-storage'
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'

export interface IGetAcademicComponentsByAllianceQuery{
  alliance_id: string // Identificador de la alianza
  pageNumber?:string,
  nPerPage?:string,
  academic_component_category?: string // Identificador de la categoria
}

export interface IGetAcademicComponentsByProgramQuery{
  alliance_id: string // Identificador de la alianza
  structure: string // Identificador del programa (Structure)
}

export interface IReorderAcademicComponentQuery {
  alliance_id: string, // Identificador de la alianza
  itemsOrdered: Array<string>, // Identificadores de componentes academicos que se desean ordenar donde la posición 0 es el primero y la posición N es la ultimo
}

export interface ICreateGhostQuery{
  academic_component_category: string
  academic_resource_category: string
  parent: string
  allianceId: string
}

export interface ICreateGhostQuery{
  academic_component_category: string
  academic_resource_category: string
  parent: string
  allianceId: string
}

export interface IGetAcademicComponentDataQuery{
  academic_components?: {
    course: string,
    chapter: string,
    lesson: string,
    resource: string,
  },
  user?: string
  academic_group_resource?: string
  flow?: string
  academic_resource_config?: string
  survey?: string
}

export interface IParamsUpdateAcademicGroupResource{
  data: FormData
  groupId: string
  allianceId?: string
}

export interface ICreateGhostResourceQuery{
  academic_resource_category: string
}

export interface IParamsUpdateFlow{
  data: any
  id: string
  alliance?: string
}

export interface IParamsUpdateSurvey{
  data: any
  id: string
}

class EditorService {

  private token: string
  private Http: any
  private screenNotification: ScreenNotificationsUtil
  private storeObject: any
  private alliance: any

  constructor() {
    this.Http = Http
    this.screenNotification = new ScreenNotificationsUtil()
    this.storeObject = store
    this.token = this.storeObject.getState().auth?.user?.token
    this.alliance = this.storeObject.getState().auth?.user?.alliance
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  /**
   * @INFO Obtener todas las alianzas
   */
  getAllAlliances = async () => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/alliance`,
      auth_token: this.token,
      params: {},
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Get todas las alianzas: ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener programas por alianza
   * @param alliance
   */
  getProgramsByAlliance = async (alliance: string) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/admin/academic-component-editor/${alliance}/programs-by-alliance`,
      auth_token: this.token,
      params: {},
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Get programas por alianza: ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      // await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener componentes académicos por alianza
   * @param alliance
   */
  getAcademicComponentsByAlliance = async (params: IGetAcademicComponentsByAllianceQuery) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/admin/academic-component-editor/${params.alliance_id}/academic-components-by-alliance`,
      auth_token: this.token,
      params: params,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    //console.log('Get componentes académicos por alianza: ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      // await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener componentes académicos por alianza
   * @param alliance
   */
  getAcademicComponentsByProgram = async (params: IGetAcademicComponentsByProgramQuery) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/admin/academic-component-editor/${params.alliance_id}/academic-components-by-program/${params.structure}`,
      auth_token: this.token,
      params: params,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    //console.log('Get componentes académicos por programa: ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      // await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Crear un componente académico
   * @param params
   * @param alliance
   */
  createAcademicComponent = async (alliance: string, params: FormData) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Academic-Component-Category': params.get('academic_component_category'),
      },
      method: 'POST',
      url: `/api/academic-component/${alliance}/create`,
      auth_token: this.token,
      params: params,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Crear nuevo componente académico:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  // /**
  //  * @INFO Eliminar
  //  * @param alliance
  //  * @param id
  //  */
  // deleteAcademicComponent = async (alliance: string, id: string) => {

  // }

  /**
   * @INFO Actualizar un componente académico
   * @param params
   * @param alliance
   */
  updateAcademicComponent = async (alliance: string, params: FormData, id: string) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Academic-Component-Category': params.get('academic_component_category'),
      },
      method: 'POST',
      url: `/api/academic-component/${alliance}/update/${id}`,
      auth_token: this.token,
      params: params,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    //console.log('Actualizar componente académico:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Reordenar componentes académicos
   * @param params
   */
  reorderAcademicComponents = async (params: IReorderAcademicComponentQuery) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'POST',
      url: `/api/academic-component/${params.alliance_id}/reorder-academic-component-nodes`,
      auth_token: this.token,
      params: params,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Reordenar componentes académicos:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Eliminar componente académico
   * @param allianceId
   * @param category
   * @param id
   */
  deleteAcademicComponent = async (allianceId: string, category: string, id: string) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Academic-Component-Category': category,
      },
      method: 'DELETE',
      url: `/api/academic-component/${allianceId}/delete/${id}`,
      auth_token: this.token,
      params: {academic_component_category: category},
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Borrar componente académico:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener alianza por ID
   * @param  allianceId
   */
  getAllianceById = async (allianceId: string) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/alliance/${allianceId}`,
      auth_token: this.token,
      params: {},
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Obtener alianza por ID:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener programa por ID
   * @param  programId
   */
  getProgramById = async (programId: string) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/structure/get/${programId}`,
      auth_token: this.token,
      params: {},
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Obtener programa por ID:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener componente académico por ID
   * @param allianceId
   * @param academicComponentId
   */
  getAcademicComponentById = async (allianceId: string, academicComponentId: string, category: string) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Academic-Component-Category': category,
      },
      method: 'GET',
      url: `/api/academic-component/${allianceId}/${academicComponentId}`,
      auth_token: this.token,
      params: {academic_component_category: category},
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Obtener componente académico por ID:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Crear un componente académico fantasma
   * @param params
   */
  createGhostAcademicComponent = async (params: ICreateGhostQuery) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Academic-Component-Category': params.academic_component_category,
      },
      method: 'POST',
      url: `/api/academic-component/${params.allianceId}/create-ghost-resource`,
      auth_token: this.token,
      params,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    //console.log('Crear un componente académico fantasma:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener data del recurso académico
   * @param params
   */
  getAcademicResourceData = async (params: IGetAcademicComponentDataQuery, configCategory?: string) => {
    this.refreshAuthToken()

    let responseData: any

    const headers = {
      'Authorization': this.token,
    }
    if(configCategory){
      // @ts-ignore
      headers['Academic-Resource-Config-Category'] = configCategory
    }

    const queryData: HttpCustomStructure = {
      headers,
      method: 'POST',
      url: `/api/data/academic-resource/fetch-resource`,
      auth_token: this.token,
      params,
    }
    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Actualizar recurso académico
   * @param params
   */
  updateAcademicResource = async (category: string, id: string, params: any) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
        'Academic-Resource-Category': category,
      },
      method: 'POST',
      url: `/api/admin/academic-resource/update/${id}`,
      auth_token: this.token,
      params,
    }
    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Actualizar configuración de recurso académico
   * @param params
   */
  updateAcademicResourceSetting = async (id: string, params: any) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'POST',
      url: `/api/admin/academic-resource-config/update/${id}`,
      auth_token: this.token,
      params,
    }
    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener lista de juegos
   */
  getGamesList = async () => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/admin/games/game`,
      auth_token: this.token,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    //console.log('Obtengo la lista de juegos:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener lista de algoritmos
   */
  getAlgorithmList = async () => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/admin/games/algorithm`,
      auth_token: this.token,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    //console.log('Obtengo la lista de algoritmos:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener los academic resource config categories
   * @param _alliance
   */
  public getAcademicResourceConfigCategories = async () => {
    this.refreshAuthToken()
    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/admin/academic-resource-config-category`,
      auth_token: this.token,
    }
    // //console.log('Params GET resource data: ', params);
    responseData = await this.Http.send(queryData)
    // //console.log('Obtengo la lista de algoritmos:  ', responseData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Crear una lección fantasma
   * @param params
   */
  public createGhostResource = async (params: ICreateGhostResourceQuery) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token
      },
      method: 'POST',
      url: `/api/admin/survey/create-ghost-survey`,
      auth_token: this.token,
      params,
    }
    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Actualizar una encuesta
   * @param _params
   * @returns
   */
  public updateSurvey = async (_params: IParamsUpdateSurvey) => {
    this.refreshAuthToken()

    const params = {..._params}

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'POST',
      url: `/api/admin/survey/update/${params.id}`,
      auth_token: this.token,
      params: {...params.data}
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Obtener la lista de encuestas
   * @returns
   */
  public getSurveyList = async () => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      headers: {
        'Authorization': this.token,
      },
      method: 'GET',
      url: `/api/admin/survey`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return {}
  }

  /**
   * @INFO Enviar el resultado a un attempt
   * @param params
   * @param qualify
   * @returns
   */
  sendAttemptResults = async (params: any, qualify: boolean) => {
    this.refreshAuthToken()

    const data = {
      ...params,
      qualify,
    }

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/event/academic-resource-attempt/attempt`,
      auth_token: this.token,
      params: data,
    }

    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData
    } else {
      await this.screenNotification.fire(responseData)
    }

    return null

  }
}

export default EditorService
